// Copyright (c) 2017 Deere & Company

import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import t from 'tcomb';

const LaborRates = t.list(LaborRate);

export const getDefaultState = () => new LaborRates([]);

export default LaborRates;




// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/state/labor-rates.js